import { Popup, Tooltip } from "@bryntum/schedulerpro";
import { GlobalEvents } from "@bryntum/schedulerpro";
import { SWIVU_ASSIST_COLUMN_MAP } from "../../../other/constants/OtherKeys.jsx";

export const SWIVU_ASSIST_UPDATE_EVENT = 'swivuAssistUpdate';

export function triggerSwivuAssistUpdate() {
  GlobalEvents.trigger(SWIVU_ASSIST_UPDATE_EVENT);
}

export default class SwivuAssistPopup extends Popup {
  static get $name() {
    return "SwivuAssistPopup";
  }

  static get type() {
    return "swivuassistpopup";
  }

  static get configurable() {
    return {
      ...super.configurable,
      modal: true,
      autoClose: false,
      minWidth: "50em",
      minHeight: "32em",
      width: "71.5em",
      height: "32.5em",
      closeAction: 'destroy',
      closable: true,
      scrollable: true,
      header: {
        cls: "bg-transparent border-0 border-b-[1px] border-b-[var(--border-color)] border-solid text-[var(--text-highlight)] [&>div]:text-swivu-lg font-semibold p-[var(--padding)] [&_.b-header-title]:overflow-visible [&_.b-tool]:text-[var(--text-highlight)] capitalize [&_.b-popup-close]:size-swivu-icon [&_.b-popup-close:hover]:bg-[var(--border-color)] [&_.b-popup-close]:transition-colors [&_.b-popup-close]:rounded-swivu-base [&_.b-popup-close]:text-swivu-icon",
        iconCls: "swivu-column-id-tooltip fa-regular fa-circle-question text-[var(--accent-color)] !mr-[0.5em] text-swivu-icon"
      },
      cls: "swivu-assist-popup swivu-styled-editor font-swivu-modern resize !rounded-swivu-base bg-[var(--bg-color)] [&_.b-panel-body-wrap]:bg-transparent [&_.b-panel-body-wrap]:m-[var(--padding)]",
      contentElementCls: "p-0",
      items: {
        swivuAssistContent: {
          type: "container",
          cls: "grid grid-cols-[repeat(3,1fr)] gap-[1em]",
          layoutStyle: {
            flexWrap: "nowrap"
          },
          items: []
        }
      },
      listeners: {
        beforeDestroy: "onEditorBeforeDestroy"
      }
    };
  }

  construct() {
    super.construct(...arguments);
    this.constructSwivuAssistUI();

    this.swivuAssistUpdateListener = GlobalEvents.on({
      [SWIVU_ASSIST_UPDATE_EVENT]: () => {
        this.constructSwivuAssistUI();
      }
    });
    const swivuAssistKey = Object.keys(SWIVU_ASSIST_COLUMN_MAP).find(key => SWIVU_ASSIST_COLUMN_MAP[key] === this.swivuAssistanceConfig.type);
    this.tooltipInstance = new Tooltip({
      forSelector: ".swivu-column-id-tooltip",
      cls: "swivu-assist-tooltip swivu-modern-tooltip",
      html: swivuAssistKey ? `Swivu Assist (ID: ${swivuAssistKey})` : "Swivu Assist"
    })
  }

  constructSwivuAssistUI() {
    if (!this.swivuAssistanceConfig) throw new Error("Please provide a swivuAssistanceConfig to editor");

    const { type, popupTitle } = this.swivuAssistanceConfig;

    this.title = popupTitle;

    this.swivuAssistanceContent = window.swivuAssistanceRecord[type];

    const { box1, box2, box3 } = this.swivuAssistanceContent || {};

    const columns = [box1, box2, box3].map((item) => ({
      type: "container",
      cls: "swivu-assist-column text-[var(--text-dimmed)] text-base",
      layoutStyle: {
        flexDirection: "column",
        flexWrap: "nowrap"
      },
      items: {
        content: {
          tag: "div",
          cls: "block",
          html: item || "TBD"
        }
      }
    }))

    this.widgetMap.swivuAssistContent.items = columns;
  }

  onEditorBeforeDestroy() {
    this.swivuAssistUpdateListener();
    this.tooltipInstance.destroy();
  }
}

SwivuAssistPopup.initClass();
